









































































































































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import Service from "@/services/DaftarRegisterPasien";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import {
  PasienAkanDatangParams,
  PasienAkanDatangRow,
  RegisterPasienTableOptions
} from "@/types/daftarRegisterPasien";

function tanggalBesok(): string {
  const d = new Date();
  d.setDate(d.getDate() + 1);

  return localISODate(d);
}

@Component({
  components: {
    VCDateTimePicker
  }
})
export default class DaftarPasienAkanDatang extends Vue {
  items: PasienAkanDatangRow[] = [];
  totalItems = 0;
  lastPage = 1;

  itemsPerPageOptions = [10, 25, 50, 100];
  loading = false;

  searchPx = "";
  tgl: string = tanggalBesok();

  options: RegisterPasienTableOptions = {
    page: 1,
    itemsPerPage: 25
  };

  private lastParams = "";

  get stateuser() {
    return userModule.user;
  }

  get isDpjp(): boolean {
    return !!this.stateuser.map_cdoc;
  }

  get headers() {
    return [
      { text: "No. RM", value: "pasien.rm" },
      { text: "Nama", value: "pasien.nama", width: "22vh" },
      { text: "JK", value: "pasien.sex", align: "center" },
      { text: "Alamat", value: "pasien.alamat" },
      { text: "Tgl Rencana Datang", value: "tgl_rencana", width: "14vh" },
      { text: "DPJP/Dokter", value: "dokter.nama" },
      { text: "Jaminan", value: "cara_bayar.nama" },
      { text: "Poli/Ralan", value: "unit.nama" },
      { text: "Aksi", value: "action", align: "center", width: "10vh" }
    ];
  }

  get tglDate(): Date | null {
    return parseLocalDate(this.tgl);
  }

  setTgl(val: Date | null) {
    this.tgl = val ? localISODate(val) : tanggalBesok();
  }

  formatTanggal(val: string | null): string {
    const d = parseLocalDate(val);

    return d ? moment(d).format("ddd, DD MMM YYYY") : "-";
  }

  @Watch("options", { deep: true })
  onOptionsChange() {
    this.getList();
  }

  resetFilter() {
    this.searchPx = "";
    this.tgl = tanggalBesok();
    this.tampilkan();
  }

  tampilkan() {
    if (this.options.page !== 1) {
      this.options = { ...this.options, page: 1 };
    }

    this.getList(true);
  }

  buildParams(): PasienAkanDatangParams {
    const params: PasienAkanDatangParams = {
      page: this.options.page,
      per_page: this.options.itemsPerPage,
      tgl: this.tgl
    };

    if (this.searchPx) params.q = this.searchPx;

    return params;
  }

  getList(paksa = false) {
    if (!this.isDpjp) {
      return;
    }

    const params = this.buildParams();
    const tandaTangan = JSON.stringify(params);

    if (!paksa && tandaTangan === this.lastParams) {
      return;
    }

    this.lastParams = tandaTangan;
    this.loading = true;

    Service.getPasienAkanDatang(params)
      .then(resp => {
        this.items = resp && resp.data ? resp.data : [];
        this.totalItems = resp && resp.meta ? resp.meta.total : 0;
        this.lastPage =
          resp && resp.meta && resp.meta.last_page ? resp.meta.last_page : 1;
      })
      .catch(() => {
        this.items = [];
        this.totalItems = 0;
        this.lastPage = 1;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  changePerPage(val: number) {
    this.options = { ...this.options, itemsPerPage: val, page: 1 };
  }

  riwayatPemeriksaan(item: PasienAkanDatangRow) {
    this.$router.push({
      name: "detail-pasien",
      params: { rm: item.pasien.rm }
    });
  }

  mounted() {
    this.$nextTick(() => this.tampilkan());
  }
}
